import { useRef } from 'react';
import MovieCard from '@/components/base/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieRowProps {
  items: Movie[];
}

export default function MovieRow({ items }: MovieRowProps) {
  const scrollerRef = useRef<HTMLDivElement>(null);

  const scrollBy = (direction: number) => {
    const node = scrollerRef.current;
    if (!node) return;
    node.scrollBy({ left: direction * node.clientWidth * 0.8, behavior: 'smooth' });
  };

  return (
    <div className="relative group/row">
      <div
        ref={scrollerRef}
        className="flex gap-4 md:gap-5 overflow-x-auto pb-2 no-scrollbar scroll-smooth"
      >
        {items.map((movie) => (
          <MovieCard
            key={movie.id}
            movie={movie}
            className="shrink-0 w-[140px] sm:w-[160px] md:w-[180px]"
          />
        ))}
      </div>

      <button
        type="button"
        aria-label="向左滚动"
        onClick={() => scrollBy(-1)}
        className="hidden lg:flex items-center justify-center absolute -left-4 top-1/3 w-10 h-10 rounded-full bg-background-50 text-foreground-800 border border-background-200 opacity-0 group-hover/row:opacity-100 transition-opacity cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="向右滚动"
        onClick={() => scrollBy(1)}
        className="hidden lg:flex items-center justify-center absolute -right-4 top-1/3 w-10 h-10 rounded-full bg-background-50 text-foreground-800 border border-background-200 opacity-0 group-hover/row:opacity-100 transition-opacity cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </div>
  );
}